import React, { FC, ReactElement } from 'react';
import { Controller, ControllerRenderProps, UseFormReturn } from 'react-hook-form';
import { ScheduledEventForm } from '../models/ScheduledEventDto';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { t } from 'i18next';

interface ModbusWriteCoilScheduleEventCommandProps {
  form: UseFormReturn<ScheduledEventForm, unknown, undefined>;
}

const ModbusWriteCoilScheduleEventCommand: FC<ModbusWriteCoilScheduleEventCommandProps> = ({
  form,
}: ModbusWriteCoilScheduleEventCommandProps) => {
  const { control } = form;

  return (
    <div className="col-span-2">
      <FormControl fullWidth size="small">
        <InputLabel id="relay-state-label">{t('scheduled_task_event_form_relay_state')}</InputLabel>
        <Controller
          name={`event.relayState`}
          control={control}
          rules={{ required: true }}
          render={({
            field,
          }: {
            field: ControllerRenderProps<ScheduledEventForm, 'event.relayState'>;
          }): ReactElement => (
            <Select
              {...field}
              labelId="relay-state-label"
              label={t('scheduled_task_event_form_relay_state')}
            >
              <MenuItem value="ON">{t('on')}</MenuItem>
              <MenuItem value="OFF">{t('off')}</MenuItem>
              <MenuItem value="TOGGLE">{t('toggle_button')}</MenuItem>
            </Select>
          )}
        />
      </FormControl>
    </div>
  );
};

export default ModbusWriteCoilScheduleEventCommand;
